module.exports = __webpack_public_path__ + "static/media/email.01a28bec.svg";